import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';


Vue.use(VueRouter);

const routes = [
  {
    path: '/energyOvertime/applyList',
    name: 'energyOvertimeApplyList',
    component: () => import('@/sub-app/energyOvertime/pages/applyList.vue'),
    meta: {
      title: '能源加时申请', 
      keepAlive: true,
    },
  },
  {
    path: '/energyOvertime/applyDetail',
    name: 'energyOvertimeApplyDetail',
    component: () => import('@/sub-app/energyOvertime/pages/applyDetail.vue'),
    meta: {
      title: '能源加时申请', 
      keepAlive: false,
    },
  },
  {
    path: '/energyOvertime/apply',
    name: 'energyOvertimeApply',
    component: () => import('@/sub-app/energyOvertime/pages/apply.vue'),
    meta: {
      title: '能源加时申请',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
